<button odxButton variant="primary" class="config-button" (click)="onClick()" data-testid="btn.newConfiguration">
  <odx-icon name="plus" variant="primary" size="medium"></odx-icon>
  <span i18n="@@floorplan.menu.button.newConfiguration">Neue Konfiguration</span>
</button>
